import { useRef } from 'react';

export const useUploadCounter = (
  setUploading: ((isUploading: boolean) => void) | undefined
) => {
  const activeUploadsRef = useRef(0);

  const startUpload = () => {
    activeUploadsRef.current += 1;
    setUploading?.(true);
  };

  const endUpload = () => {
    activeUploadsRef.current = Math.max(0, activeUploadsRef.current - 1);
    if (activeUploadsRef.current === 0) {
      setUploading?.(false);
    }
  };

  return { startUpload, endUpload };
};
